<p>single-wishlist works!</p>
